@if (idPlantilla) {
  <div class="workSpace">
    <!-- Titulo -->
    <div class="w3-container w3-container-template">
      <!--Titulo de modulo y subtitulo-->
      <div class="padreizquierda w3-quarter">
        <div class="w3-row hijoizquierda centradoVertical">
          <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
          <span class="w3-text-deep-orange">&bull;</span>
          <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
        </div>
      </div>
      <!--Filtros-->
      <div class="w3-rest">
        <!--Filtro años-->
        <div class="w3-fourty">
          <app-filters 
            [name]="'filtros.per' | translate"
            [array]="Periodos"
            [typeFilter]="Filters.PERIOD"
            (eventClick)="cambioPeriodo($event)">
          </app-filters>
        </div>
      </div>
    </div>
    <!-- TABLERO -->
    <div class="w3-row workSpaceTab">
      <!--zona superior del tablero -->
      <div class="zonaSuperior">
        <!--Tabla-->
        <div class="zonaTabla w3-white">
          <div class="headers w3-titulo-contenidomenuSC "> <!--barra del titulo-->
            <div class="w3-half"> <!--titulo tabla-->
              <span class="w3-margin-left-contenido">{{
                'credito.estimaciones.tituloTabla' | translate}}
              </span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
            </div>
            <div class="w3-rest w3-right "> <!--menu tabla-->
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuTabla">
                more_vert
              </mat-icon>
              <mat-menu #menuTabla="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="exportarTabla()">
                  <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <!--Contenido Tabla-->
          <div class="tabla w3-scroll">
            @if (datos.length !== 0) {
              <table class="w3-table borderInf">
                <!--Titulos tabla-->
                <thead>
                  <!--titulos-->
                  <tr class="w3-center">
                    <th class="stikyColumBlanco"></th>
                    <th class="stikyColumBlanco"></th>
                    <th class="stikyColumBlanco"></th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" colspan="2">{{'credito.estimaciones.titulo1Tabla'| translate }}</th>
                    @if(idPlantilla === 7){
                      <th class="stikyColumBlanco"></th>
                      <th class="stikyColumBlanco"></th>
                    }                      
                    <th class="w3-table-titleLow stikyColumCon" colspan="4">{{'credito.estimaciones.titulo2Tabla'| translate }}</th>
                  </tr>
                  <!--encabezados-->
                  <tr class="w3-table-title alinCenter">
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado1' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado2' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado3' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado4' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado5' | translate}}</th>
                    @if (idPlantilla === 7) {
                      <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado10' | translate}}</th>
                      <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado11' | translate}}</th>
                    }
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado6' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado7' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado8' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon2">{{'credito.estimaciones.encabezado9' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (i of datos; track $index) {
                      <!--Filas de la tabla contenido general-->
                    <tr class="w3-table-trtd borderInfLow">
                      <td class="borderAllLow ">
                        <span>{{i.categoria}}</span>
                      </td>
                      <td class="borderAllLow alinCenter">
                        <span>{{i.calif}}</span>
                      </td>
                      <td class="borderAllLow alinCenter">
                        <span>{{i.diasMora}}</span>
                      </td>
                      <td class="borderAllLow marginDer alinRight">
                        <span>{{formatoNum(i.numero, false)}}</span>
                      </td>
                      <td class="borderAllLow marginDer alinRight">
                        <span>{{formatoNum(i.saldo, false)}}</span>
                      </td>
                      @if(idPlantilla === 7){
                        <td class="borderAllLow marginDer alinRight">
                          <span>{{formatoNum(i.garantia, false)}}</span>
                        </td>
                        <td class="borderAllLow marginDer alinRight">
                          <span>{{formatoNum(i.deducciones, false)}}</span>
                        </td>
                      }
                      <td class="borderAllLow alinCenter">
                        <span>{{i.porcenReq.toFixed(1) + '%'}}</span>
                      </td>
                      <td class="borderAllLow marginDer alinRight">
                        <span>{{formatoNum(i.montoReq, false)}}</span>
                      </td>
                      <td class="borderAllLow marginDer alinRight">
                        <span>{{formatoNum(i.montoCons, false)}}</span>
                      </td>
                      <td class="borderAllLow alinCenter">
                        <span>{{i.porcenCober.toFixed(1)+ '%'}}</span>
                      </td>
                    </tr>
                  }                  
                </tbody>
                <!--Fila Totales-->
                <tbody>
                  <tr class="w3-table-trtd filaTotales">
                    <td class="borderAllLow">
                      <span class=" alinCenter txtTotales">{{totales.categoria}}</span>
                    </td>
                    <td class="borderLowInf"></td>
                    <td class="borderLowInf"></td>
                    <td class="borderAllLow marginDer alinRight txtTotales">
                      <span>{{formatoNum(totales.numero, false)}}</span>
                    </td>
                    <td class="borderAllLow marginDer alinRight txtTotales">
                      <span>{{formatoNum(totales.saldo, false)}}</span>
                    </td>
                    @if (idPlantilla === 7) {
                      <td class="borderAllLow marginDer alinRight txtTotales">
                        <span>{{formatoNum(totales.garantia, false)}}</span>
                      </td>
                      <td class="borderAllLow marginDer alinRight txtTotales">
                        <span>{{formatoNum(totales.deducciones, false)}}</span>
                      </td>
                    }                      
                    <td class="borderAllLow alinCenter txtTotales">
                      <span>{{totales.porcenReq + '%'}}</span>
                    </td>
                    <td class="borderAllLow marginDer alinRight txtTotales">
                      <span>{{formatoNum(totales.montoReq, false)}}</span>
                    </td>
                    <td class="borderAllLow marginDer alinRight txtTotales">
                      <span>{{formatoNum(totales.montoCons, false)}}</span>
                    </td>
                    <td class="borderAllLow alinCenter txtTotales">
                      <span>{{totales.porcenCober +'%'}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            }@else {
              <div class="preview-background">
                <div class="page">
                  <ngx-skeleton-loader count="7" [theme]="{ 
                    'border-radius': '10px',
                    height: '2vh',
                    width: '95vw',
                  }" />
                </div>
              </div>
            }
          </div>
        </div>                
      </div>  
      @if(idPlantilla === 12){
          <!--zona inferior del tablero-->
        <div class="zonaInferior ">
          <!--Zona izquierda-->
          <div class="infIzq w3-white" id="grafIzq">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span class="w3-margin-left-contenido">{{'credito.estimaciones.tituloIzquierdo' | translate}} &bull;</span>
                <span class="w3-subtitulo"> {{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (!tablaGraficaIzq) {
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="showEtiIzq = !showEtiIzq" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                    {{ showEtiIzq ? 'label_off' : 'label' }}
                  </mat-icon>
                  <mat-icon class="iconoMen w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('izq')">
                    zoom_out_map
                  </mat-icon>
                }              
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica="matMenu">
                  @if(!tablaGraficaIzq){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioContenedorEstimaciones(true,undefined)">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }                
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaIzq){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(1, 'credito.estimaciones.tituloIzquierdo')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.BAR}" [disabled]="tipoIzq === tipoGraf.BAR" (click)="cambioContenedorEstimaciones(false, tipoGraf.BAR)" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.LINE}" [disabled]="tipoIzq === tipoGraf.LINE" (click)="cambioContenedorEstimaciones(false, tipoGraf.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.AREA}" [disabled]="tipoIzq === tipoGraf.AREA" (click)="cambioContenedorEstimaciones(false, tipoGraf.AREA)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaIzq){
                <div class="w3-center" style="margin-left: auto; margin-right: auto; height: 7vh;">
                  <!--<span class="encabezado w3-balance-bluep">Estimaciones constituidas/Estimaciones requeridas</span>-->
                  <div class="headers"></div>
                </div>
                <table class="w3-table w3-scroll " style="width: 85%; margin-left: auto; margin-right: auto;">
                  <tbody>
                    @for (i of estimaciones; track $index) {
                      <tr class="w3-table-trtd">
                        <td class="alincenter celdaizq">{{formatoNum(i.cantidad, true) + "%"}}</td>
                        <td class="alinLeft textoTabla " >
                          <span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span>
                        </td>
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {
                <app-graficador
                  [etiquetas]="showEtiIzq"
                  [data]="dataIzq"
                  [labels]="etiquetasIzq"
                  [type]="tipoIzq"
                  [axisX]="xAxisLabelIzq"
                  [axisY]="yAxisLabelIzq"
                  [zona]="1"
                  [colors]="color"
                  [formatEtiquetas]="true"
                  [changeLabel]="changeLabelIzq"
                  [legend]="{enabled: true, position: 'right'}"
                  [animations]="true"
                  [altoEtiquetasX]="100"
                ></app-graficador>
              }
            </div>
          </div>
          <!--Zona centro-->
          <div class="infCentro w3-white " id="grafCen">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span class="w3-margin-left-contenido">{{'credito.estimaciones.tituloCentro' | translate}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if(!tablaGraficaCen){
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="showEtiCen = !showEtiCen" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                    {{ showEtiCen ? 'label_off' : 'label' }}
                  </mat-icon>
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('cen')">
                    zoom_out_map
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica2">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica2="matMenu">
                  @if(!tablaGraficaCen){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="cambioContenedorCobertura(true,undefined)">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item  [matMenuTriggerFor]="tipoGrafica2">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaCen){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="exportarGrafica(2, 'credito.estimaciones.tituloCentro')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica2="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.BAR}" [disabled]="tipoCen === tipoGraf.BAR" (click)="cambioContenedorCobertura(false, tipoGraf.BAR)" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.LINE}" [disabled]="tipoCen === tipoGraf.LINE" (click)="cambioContenedorCobertura(false, tipoGraf.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.AREA}" [disabled]="tipoCen === tipoGraf.AREA" (click)="cambioContenedorCobertura(false, tipoGraf.AREA)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaCen){
                <div class="w3-center" style="margin-left: auto; margin-right: auto; height: 7vh;">
                  <div class="headers"></div>
                </div>
                <table class="w3-table w3-scroll" style="width: 80%; margin-left: auto; margin-right: auto;">
                  <tbody>
                    @for (i of cobertura; track $index) {
                      <tr class="w3-table-trtd">
                        <td class="alincenter celdacen">{{formatoNum(i.cantidad, true) + "%"}}</td>
                        <td class="alinLeft textoTabla ">
                          <span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span>
                        </td>
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {
                <app-graficador
                  [etiquetas]="showEtiCen"
                  [data]="dataCen"
                  [labels]="etiquetasCen"
                  [type]="tipoCen"
                  [axisX]="xAxisLabelCen"
                  [axisY]="yAxisLabelCen"
                  [zona]="2"
                  [colors]="color"
                  [formatEtiquetas]="false"
                  [changeLabel]="changeLabelCen"
                  [legend]="{enabled: true, position: 'right'}"
                  [animations]="true"
                ></app-graficador>
              }
            </div>
          </div>
          <!--Zona derecha-->
          <div class="infDer w3-white " id="grafDer">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span matTooltip="{{'credito.estimaciones.tituloDerecho' | translate}}&bull; {{escrituraPeriodo(subTitles)}}">
                  <span class="w3-margin-left-contenido">{{
                    'credito.estimaciones.tituloDerecho' | translate}}
                  </span>
                  <span class="w3-margin-left-contenido">&bull;</span>
                  <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
                </span>
              </div>
              <div class="w3-rest w3-right">
                @if(!tablaGraficaDer){
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('der')">
                    zoom_out_map
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica3">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica3="matMenu">
                  @if(!tablaGraficaDer){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="cambioContenedorAfectacion(true,'bar')">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item  [matMenuTriggerFor]="tipoGrafica3">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaDer){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="exportarGrafica(3, 'credito.estimaciones.tituloDerecho')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica3="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoDer === 'bar'}" [disabled]="tipoDer === 'bar'" (click)="cambioContenedorAfectacion(false, 'bar')" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoDer === 'treemap'}" [disabled]="tipoDer === 'treemap'" (click)="cambioContenedorAfectacion(false, 'treemap')">
                    <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                    <span>{{'credito.estimaciones.graficaMapa'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaDer){
                <table class="w3-table w3-scroll" style="width: 95%; margin-left: auto; margin-right: auto;">
                  <thead>
                    <tr class="w3-table-title alinCenter">
                      <th class="w3-border-right-balance stikyColumCon2"></th>
                      @for (tit of etiquetasDer; track $index) {<th class="w3-border-right-balance marginsH">{{tit}}</th>}                        
                    </tr>
                  </thead>
                  <tbody>
                    @for (i of afectacion; track i; let pos = $index) {
                      <tr class="w3-table-trtd borderInfLow">
                        <td class="alinLeft borderAllLow" style="line-height: 1.2;"><span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span></td>
                        @for (p of i.pares; track $index) {
                          <td class="alinRight marginsH borderAllLow">
                            @if(pos === 2){<span>{{formatoNum(p,true)}} %</span>
                            }@else {<span>{{formatoNum(p,false)}} </span>}                                
                          </td>
                        }
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {
                <app-graficador
                  [etiquetas]="showEtiDer"
                  [data]="dataDer"
                  [labels]="etiquetasDer"
                  [type]="tipoDer"
                  [axisX]="xAxisLabelDer"
                  [axisY]="yAxisLabelDer"
                  [zona]="3"
                  [colors]="color"
                  [formatEtiquetas]="false"
                  [changeLabel]="changeLabelDer"
                  [legend]="{enabled: true, position: 'bottom'}"
                  [animations]="true"
                ></app-graficador>
              }
            </div>
          </div>
        </div>
      }
      @if(idPlantilla === 7){
          <!--zona inferior del tablero-->
        <div class="zonaInferior ">
          <!--Zona izquierda-->
          <div class="infIzq w3-white" id="grafIzq">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span class="w3-margin-left-contenido">{{'credito.estimaciones.tituloIzquierdo' | translate}} | {{encPar}} &bull;</span>
                <span class="w3-subtitulo"> {{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if (!tablaGraficaIzq) {
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="showEtiIzq = !showEtiIzq" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                    {{ showEtiIzq ? 'label_off' : 'label' }}
                  </mat-icon>
                  <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('izq')">
                    zoom_out_map
                  </mat-icon>
                }              
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="par">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}"><span class="material-symbols-outlined">filter_list</span></mat-icon>
                    <span>PAR</span>
                  </button>
                  @if(!tablaGraficaIzq){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioContenedorEstimaciones(true,undefined)">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }                
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaIzq){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(1, 'credito.estimaciones.tituloIzquierdo')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.BAR}" [disabled]="tipoIzq === tipoGraf.BAR" (click)="cambioContenedorEstimaciones(false, tipoGraf.BAR)" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.LINE}" [disabled]="tipoIzq === tipoGraf.LINE" (click)="cambioContenedorEstimaciones(false, tipoGraf.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoIzq === tipoGraf.AREA}" [disabled]="tipoIzq === tipoGraf.AREA" (click)="cambioContenedorEstimaciones(false, tipoGraf.AREA)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #par="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioPar(0)">
                    <span>1</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioPar(1)">
                    <span>30</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioPar(2)">
                    <span>60</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambioPar(3)">
                    <span>90</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaIzq){
                <div class="w3-center" style="margin-left: auto; margin-right: auto; height: 7vh;">
                  <!--<span class="encabezado w3-balance-bluep">Estimaciones constituidas/Estimaciones requeridas</span>-->
                  <div class="headers"></div>
                </div>
                <table class="w3-table w3-scroll " style="width: 85%; margin-left: auto; margin-right: auto;">
                  <tbody>
                    @for (i of estimaciones; track $index) {
                      <tr class="w3-table-trtd">
                        <td class="alincenter celdaizq">{{formatoNum(i.cantidad, true) + "%"}}</td>
                        <td class="alinLeft textoTabla " >
                          <span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span>
                        </td>
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {
                @if(dataIzq.length !== 0){
                  <app-graficador
                    [etiquetas]="showEtiIzq"
                    [data]="dataIzq"
                    [labels]="etiquetasIzq"
                    [type]="tipoIzq"
                    [axisX]="xAxisLabelIzq"
                    [axisY]="yAxisLabelIzq"
                    [zona]="1"
                    [colors]="color"
                    [formatEtiquetas]="true"
                    [changeLabel]="changeLabelIzq"
                    [legend]="{enabled: true, position: 'right'}"
                    [animations]="true"
                    [altoEtiquetasX]="100"
                  ></app-graficador>
                }@else {
                  <div class="preview-background">
                    <div class="page">
                      <ngx-skeleton-loader count="1" [theme]="{ 
                        'border-radius': '10px',
                        height: '38vh',
                        width: '30vw',
                      }" />
                    </div>
                  </div>    
                }            
              }
            </div>
          </div>
          <!--Zona centro-->
          <div class="infCentro w3-white " id="grafCen">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span class="w3-margin-left-contenido">{{'credito.estimaciones.tituloCentro' | translate}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right">
                @if(!tablaGraficaCen){
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="showEtiCen = !showEtiCen" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                    {{ showEtiCen ? 'label_off' : 'label' }}
                  </mat-icon>
                  <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('cen')">
                    zoom_out_map
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica2">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica2="matMenu">
                  @if(!tablaGraficaCen){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="cambioContenedorCobertura(true,undefined)">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item  [matMenuTriggerFor]="tipoGrafica2">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaCen){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="exportarGrafica(2, 'credito.estimaciones.tituloCentro')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica2="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.BAR}" [disabled]="tipoCen === tipoGraf.BAR" (click)="cambioContenedorCobertura(false, tipoGraf.BAR)" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.LINE}" [disabled]="tipoCen === tipoGraf.LINE" (click)="cambioContenedorCobertura(false, tipoGraf.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoCen === tipoGraf.AREA}" [disabled]="tipoCen === tipoGraf.AREA" (click)="cambioContenedorCobertura(false, tipoGraf.AREA)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaCen){
                <div class="w3-center" style="margin-left: auto; margin-right: auto; height: 7vh;">
                  <div class="headers"></div>
                </div>
                <table class="w3-table w3-scroll" style="width: 80%; margin-left: auto; margin-right: auto;">
                  <tbody>
                    @for (i of cobertura; track $index) {
                      <tr class="w3-table-trtd">
                        <td class="alincenter celdacen">{{formatoNum(i.cantidad, true) + "%"}}</td>
                        <td class="alinLeft textoTabla ">
                          <span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span>
                        </td>
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {
                @if(dataCen.length > 0){
                  <app-graficador
                    [etiquetas]="showEtiCen"
                    [data]="dataCen"
                    [labels]="etiquetasCen"
                    [type]="tipoCen"
                    [axisX]="xAxisLabelCen"
                    [axisY]="yAxisLabelCen"
                    [zona]="2"
                    [colors]="color"
                    [formatEtiquetas]="true"
                    [changeLabel]="changeLabelCen"
                    [legend]="{enabled: true, position: 'right'}"
                    [animations]="true"
                    [altoEtiquetasX]="100"
                  ></app-graficador>  
                }@else {
                  <div class="preview-background">
                    <div class="page">
                      <ngx-skeleton-loader count="1" [theme]="{ 
                        'border-radius': '10px',
                        height: '38vh',
                        width: '30vw',
                      }" />
                    </div>
                  </div> 
                }
              }
            </div>
          </div>
          <!--Zona derecha-->
          <div class="infDer w3-white " id="grafDer">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-threequarter textoOverFlow" >  <!--titulo tabla-->
                <span matTooltip="{{'credito.estimaciones.tituloDerecho' | translate}} | {{encPar}} &bull; {{escrituraPeriodo(subTitles)}}">
                  <span class="w3-margin-left-contenido">{{
                    'credito.estimaciones.tituloDerecho' | translate}}
                  </span>
                  <span> | {{encPar}}</span>
                  <span class="w3-margin-left-contenido">&bull;</span>
                  <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
                </span>
              </div>
              <div class="w3-rest w3-right">
                @if(!tablaGraficaDer){
                  <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('der')">
                    zoom_out_map
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica3">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafica3="matMenu">
                  @if(!tablaGraficaDer){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="cambioContenedorAfectacion(true,'bar')">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                  }
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item  [matMenuTriggerFor]="tipoGrafica3">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                  </button>
                  @if(!tablaGraficaDer){
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item  (click)="exportarGrafica(3, 'credito.estimaciones.tituloDerecho')">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGrafica3="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoDer === 'bar'}" [disabled]="tipoDer === 'bar'" (click)="cambioContenedorAfectacion(false, 'bar')" >
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoDer === 'treemap'}" [disabled]="tipoDer === 'treemap'" (click)="cambioContenedorAfectacion(false, 'treemap')">
                    <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                    <span>{{'credito.estimaciones.graficaMapa'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="contenido">
              <!--Contenedor Tabla-->
              @if(tablaGraficaDer){
                <div class="w3-center" style="margin-left: auto; margin-right: auto; height: 7vh;">
                  <div class="headers"></div>
                </div>
                <table class="w3-table w3-scroll" style="width: 80%; margin-left: auto; margin-right: auto;">
                  <tbody>
                    @for (i of afectacion; track i; let pos = $index) {
                      <tr class="w3-table-trtd">
                        @if(pos != 2){<td class="alinRight celdader">{{formatoNum(i.cantidad, false)}}</td>}
                        @if(pos == 2){<td class="alinRight celdader">{{formatoNum(i.cantidad, true) + "%"}}</td>}
                        <td class="alinLeft textoTabla" >
                          <span matTooltip="{{i.descripcion}}">{{i.descripcion}}</span>
                        </td>
                      </tr>
                    }                  
                  </tbody>
                </table>
              }@else {

              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!--Modal ampliar grafica-->
<div id="ampliar" class="w3-modal" (click)="clickFuera($event)">
  <div class="w3-modal-content" style="width: 80%;">
    <div class="w3-row w3-titulo-contenidomenu w3-header-cuadrante">
      <!--Titulo grafica modal-->
      <div class="w3-half">
        <div class="hijoizquierdaTitle" >
          <span class="w3-margin-left-contenido">{{'credito.estimaciones.titulo' + tituloModal | translate}} &bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right">
        @if(grafAmpIzq){
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showEtiIzq = !showEtiIzq" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showEtiIzq ? 'label_off' : 'label' }}
          </mat-icon>
          <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 18px;"[ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(1, 'credito.estimaciones.tituloCentro')" matTooltip="{{'menu.exportar' | translate}}">
            image
          </mat-icon>
        }
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" style="margin-right: 24px;" (click)="closeModal()">clear</mat-icon>
      </div>
    </div> 
    
    <!--area grafica-->
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
        <div class="w3-row contentGraf">
          @if (grafAmpIzq) {
            <app-graficador
              [etiquetas]="showEtiIzq"
              [data]="dataIzq"
              [labels]="etiquetasIzq"
              [type]="tipoIzq"
              [axisX]="xAxisLabelIzq"
              [axisY]="yAxisLabelIzq"
              [zona]="4"
              [colors]="color"
              [formatEtiquetas]="true"
              [changeLabel]="changeLabelIzq"
              [legend]="{enabled: true, position: 'right'}"
              [animations]="true"
            ></app-graficador>
          }
          @if(grafAmpCen){
            <app-graficador
              [etiquetas]="showEtiCen"
              [data]="dataCen"
              [labels]="etiquetasCen"
              [type]="tipoCen"
              [axisX]="xAxisLabelCen"
              [axisY]="yAxisLabelCen"
              [zona]="5"
              [colors]="color"
              [formatEtiquetas]="false"
              [changeLabel]="changeLabelCen"
              [legend]="{enabled: true, position: 'right'}"
              [animations]="true"
            ></app-graficador>
          }
          @if (grafAmpDer) {
            <app-graficador
              [etiquetas]="showEtiDer"
              [data]="dataDer"
              [labels]="etiquetasDer"
              [type]="tipoDer"
              [axisX]="xAxisLabelDer"
              [axisY]="yAxisLabelDer"
              [zona]="6"
              [colors]="color"
              [formatEtiquetas]="false"
              [changeLabel]="changeLabelDer"
              [legend]="{enabled: true, position: 'bottom'}"
              [animations]="true"
            ></app-graficador>
          }
        </div>
    </div>
  </div>
</div>

